"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecificationType = exports.AgreementType = void 0;
const mobx_1 = require("mobx");
const ApiUtil_1 = __importDefault(require("../util/ApiUtil"));
var AgreementType;
(function (AgreementType) {
    AgreementType["TRAFFIC_DATA_ANALYSIS"] = "TRAFFIC_DATA_ANALYSIS";
    AgreementType["DIRECT_MARKETING"] = "DIRECT_MARKETING";
    AgreementType["LOCATION_DATA_ANALYSIS"] = "LOCATION_DATA_ANALYSIS";
})(AgreementType || (exports.AgreementType = AgreementType = {}));
var PartyPrivacyProfileStatus;
(function (PartyPrivacyProfileStatus) {
    PartyPrivacyProfileStatus["SIGNED"] = "SIGNED";
})(PartyPrivacyProfileStatus || (PartyPrivacyProfileStatus = {}));
var SpecificationType;
(function (SpecificationType) {
    SpecificationType["B2C_REPRESENTATIVE_SELF"] = "B2C_REPRESENTATIVE_SELF";
    SpecificationType["B2B_REPRESENTATIVE"] = "B2B_REPRESENTATIVE";
})(SpecificationType || (exports.SpecificationType = SpecificationType = {}));
class PartyPrivacyProfileStore {
    constructor(rootStore) {
        Object.defineProperty(this, "agreements", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "latestSpec", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "preparedProfiles", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "profileIsLatestSpec", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isProfileCreationLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isProfileCreationError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isProfileSigningLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isProfileSigningError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isProfileGetLoading", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "isProfileGetError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "consentStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dealerConsentStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "buildAgreementsAndLatestSpec", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data) => {
                var _a, _b, _c;
                this.latestSpec = data === null || data === void 0 ? void 0 : data.partyPrivacyProfileSpecification;
                this.profileIsLatestSpec = (_a = data === null || data === void 0 ? void 0 : data.profileIsLatestSpec) !== null && _a !== void 0 ? _a : false;
                if (this.profileIsLatestSpec) {
                    this.agreements = (_c = (_b = data === null || data === void 0 ? void 0 : data.partyPrivacyProfile) === null || _b === void 0 ? void 0 : _b.partyPrivacyAgreements) !== null && _c !== void 0 ? _c : [];
                    this.agreements.map((agreement) => (agreement.checkboxValue = agreement.agreementGiven));
                }
                else {
                    this.agreements = [];
                }
                this.latestSpec.specificationCharacteristics.forEach((char) => this.addAgreementIfMissing(char.name));
            }
        });
        Object.defineProperty(this, "addAgreementIfMissing", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (agreementType) => {
                const profileHasNoAgreementOfGivenType = !this.getAgreement(agreementType);
                if (profileHasNoAgreementOfGivenType) {
                    this.agreements.push((0, mobx_1.observable)({
                        id: null,
                        agreementType,
                        agreementGiven: null,
                        checkboxValue: false
                    }));
                }
            }
        });
        Object.defineProperty(this, "setAgreementValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (agreementType, value) => {
                const agreement = this.getAgreement(agreementType);
                if (!!agreement) {
                    agreement.checkboxValue = value;
                }
            }
        });
        Object.defineProperty(this, "mapSignersToResource", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (signer) => {
                return {
                    agreedByParty: signer.personId,
                    signature: this.dealerConsentStore.signatureToBase64(signer.signature)
                };
            }
        });
        (0, mobx_1.makeObservable)(this);
        this.ssoStore = rootStore.ssoStore;
        this.consentStore = rootStore.consentStore;
        this.dealerConsentStore = rootStore.dealerConsentStore;
        (0, mobx_1.autorun)(() => {
            if (this.ssoStore.customerId) {
                this.getProfileAgreementsWithLatestSpec();
            }
        });
    }
    get allAgreementsTrue() {
        var _a;
        return (_a = this.agreements) === null || _a === void 0 ? void 0 : _a.every((agreement) => agreement.checkboxValue === true);
    }
    async getProfileAgreementsWithLatestSpec() {
        const searchDto = {
            specType: this.ssoStore.isPrivateCustomer ? SpecificationType.B2C_REPRESENTATIVE_SELF : SpecificationType.B2B_REPRESENTATIVE,
            profileStatuses: [PartyPrivacyProfileStatus.SIGNED]
        };
        this.isProfileGetLoading = true;
        this.isProfileGetError = false;
        await ApiUtil_1.default.post('/privacy-profile/get', searchDto)
            .then((0, mobx_1.action)((response) => this.buildAgreementsAndLatestSpec(response === null || response === void 0 ? void 0 : response.data)))
            .then((0, mobx_1.action)(() => (this.isProfileGetLoading = false)))
            .catch((0, mobx_1.action)(() => {
            this.isProfileGetError = true;
            this.isProfileGetLoading = false;
        }));
    }
    getAgreement(agreementType) {
        return this.agreements.find((agreement) => agreement.agreementType === agreementType);
    }
    getCheckBoxValue(agreementType) {
        return this.getAgreement(agreementType).checkboxValue;
    }
    get agreementChoices() {
        return this.agreements.map((a) => a.agreementType.toLowerCase() + (a.checkboxValue === true ? '_yes' : '_no')).join('-');
    }
    get hasChangedAgreements() {
        var _a;
        const changedAgreementCount = (_a = this.agreements) === null || _a === void 0 ? void 0 : _a.reduce((count, agreement) => (agreement.agreementGiven !== agreement.checkboxValue ? count + 1 : count), 0);
        return changedAgreementCount > 0;
    }
    async createPreparedOnScreenProfile() {
        const privacyProfileCreation = {
            agreedByParties: this.dealerConsentStore.selectedConsentSigners.map((signer) => signer.personId),
            partyPrivacyProfileSpecificationId: this.latestSpec.id,
            partyType: this.ssoStore.isPrivateCustomer ? 'PERSON' : 'LEGAL_ENTITY',
            givenAgreements: this.getAgreementsResource()
        };
        this.isProfileCreationLoading = true;
        this.isProfileCreationError = false;
        await ApiUtil_1.default.post('/privacy-profile/on-screen/prepare', privacyProfileCreation)
            .then((0, mobx_1.action)((preparedProfiles) => (this.preparedProfiles = preparedProfiles.data)))
            .catch((0, mobx_1.action)(() => (this.isProfileCreationError = true)))
            .finally((0, mobx_1.action)(() => (this.isProfileCreationLoading = false)));
    }
    async signOnScreenProfile() {
        const profileSigningResource = {
            partyType: this.ssoStore.isPrivateCustomer ? 'PERSON' : 'LEGAL_ENTITY',
            agreedByParties: this.dealerConsentStore.selectedConsentSigners.map(this.mapSignersToResource),
            employeeSigner: {
                employeeUsername: this.ssoStore.auth.dealer.userName,
                signature: this.dealerConsentStore.latestEmployeeSignature
            }
        };
        this.isProfileSigningLoading = true;
        this.isProfileSigningError = false;
        await ApiUtil_1.default.post('/privacy-profile/on-screen/sign', profileSigningResource)
            .then((0, mobx_1.action)(() => (this.isProfileSigningLoading = false)))
            .catch((0, mobx_1.action)(() => (this.isProfileSigningError = true)));
    }
    async signClickAcceptProfile() {
        this.isProfileSigningLoading = true;
        this.isProfileSigningError = false;
        await ApiUtil_1.default.post('/privacy-profile/click-accept/sign', {
            givenAgreements: this.getAgreementsResource(),
            profileSpecificationId: this.latestSpec.id
        })
            .then((0, mobx_1.action)(() => (this.isProfileSigningLoading = false)))
            .catch((0, mobx_1.action)(() => (this.isProfileSigningError = true)));
    }
    getAgreementsResource() {
        return this.agreements.map((agreement) => ({
            agreementType: agreement.agreementType,
            value: agreement.checkboxValue
        }));
    }
}
exports.default = PartyPrivacyProfileStore;
__decorate([
    mobx_1.observable
], PartyPrivacyProfileStore.prototype, "agreements", void 0);
__decorate([
    mobx_1.observable
], PartyPrivacyProfileStore.prototype, "latestSpec", void 0);
__decorate([
    mobx_1.observable
], PartyPrivacyProfileStore.prototype, "preparedProfiles", void 0);
__decorate([
    mobx_1.observable
], PartyPrivacyProfileStore.prototype, "profileIsLatestSpec", void 0);
__decorate([
    mobx_1.observable
], PartyPrivacyProfileStore.prototype, "isProfileCreationLoading", void 0);
__decorate([
    mobx_1.observable
], PartyPrivacyProfileStore.prototype, "isProfileCreationError", void 0);
__decorate([
    mobx_1.observable
], PartyPrivacyProfileStore.prototype, "isProfileSigningLoading", void 0);
__decorate([
    mobx_1.observable
], PartyPrivacyProfileStore.prototype, "isProfileSigningError", void 0);
__decorate([
    mobx_1.observable
], PartyPrivacyProfileStore.prototype, "isProfileGetLoading", void 0);
__decorate([
    mobx_1.observable
], PartyPrivacyProfileStore.prototype, "isProfileGetError", void 0);
__decorate([
    mobx_1.computed
], PartyPrivacyProfileStore.prototype, "allAgreementsTrue", null);
__decorate([
    mobx_1.action
], PartyPrivacyProfileStore.prototype, "getProfileAgreementsWithLatestSpec", null);
__decorate([
    mobx_1.action
], PartyPrivacyProfileStore.prototype, "buildAgreementsAndLatestSpec", void 0);
__decorate([
    mobx_1.action
], PartyPrivacyProfileStore.prototype, "addAgreementIfMissing", void 0);
__decorate([
    mobx_1.action
], PartyPrivacyProfileStore.prototype, "setAgreementValue", void 0);
__decorate([
    mobx_1.computed
], PartyPrivacyProfileStore.prototype, "agreementChoices", null);
__decorate([
    mobx_1.computed
], PartyPrivacyProfileStore.prototype, "hasChangedAgreements", null);
__decorate([
    mobx_1.action
], PartyPrivacyProfileStore.prototype, "createPreparedOnScreenProfile", null);
__decorate([
    mobx_1.action
], PartyPrivacyProfileStore.prototype, "signOnScreenProfile", null);
__decorate([
    mobx_1.action
], PartyPrivacyProfileStore.prototype, "signClickAcceptProfile", null);
